define('ProductsHelper',['require','exports','module'],function (require, exports, module) {
  "use strict";

  var ProductsHelper = {
    PRODUCTS: {
      free: "MD Free 5K Emails",
      "lite-100000": "MD Lite 100K Emails",
      "pro-100000": "MD Pro 100K Emails",
      "pro-60000": "MD Pro 60K Emails",
      "lite-750000": "MD Lite 750K Emails",
      "pro-150000": "MD Pro 150K Emails",
      "lite-60000": "MD Lite 60K Emails",
      "lite-300000": "MD Lite 300K Emails",
      "pro-40000": "MD Pro 40K Emails",
      "lite-40000": "MD Lite 40K Emails",
      "lite-150000": "MD Lite 150K Emails",
      "pro-300000": "MD Pro 300K Emails",
      "lite-2000000": "MD Lite 2M Emails",
      "lite-500000": "MD Lite 500K Emails",
      "lite-20000": "MD Lite 20K Emails",
      "pro-20000": "MD Pro 20K Emails",
      "pro-500000": "MD Pro 500K Emails",
      "lite-1000000": "MD Lite 1M Emails",
      "total-2000000": "MD Total 2M Emails",
      "total-500000": "MD Total 500K Emails",
      "total-300000": "MD Total 300K Emails",
      "total-1000000": "MD Total 1M Emails",
      "pro-750000": "MD Pro 750K Emails",
      "total-40000": "MD Total 40K Emails",
      "total-100000": "MD Total 100K Emails",
      "total-60000": "MD Total 60K Emails",
      "total-750000": "MD Total 750K Emails",
      "total-20000": "MD Total 20K Emails",
      "pro-2000000": "MD Pro 2M Emails",
      "pro-1000000": "MD Pro 1M Emails",
      "total-150000": "MD Total 150K Emails",
      "total-10000000": "MD Total 10M Emails",
      "pro-5000000": "MD Pro 5M Emails",
      "total-5000000": "MD Total 5M Emails",
      "pro-10000000": "MD Pro 10M Emails",
      "appsumo-50000": "License Tier 2",
      "appsumo-100000": "License Tier 3",
      "appsumo-15000": "License Tier 1",
      "pro-8000000": "MD Pro 8M Emails",
      "total-15000000": "MD Total 15M Emails",
      "total-3000000": "MD Total 3M Emails",
      "total-8000000": "MD Total 8M Emails",
      "pro-3000000": "MD Pro 3M Emails",
      "pro-7000000": "MD Pro 7M Emails",
      "pro-25000000": "MD Pro 25M Emails",
      "total-4000000": "MD Total 4M Emails",
      "total-25000000": "MD Total 25M Emails",
      "pro-4000000": "MD Pro 4M Emails",
      "pro-15000000": "MD Pro 15M Emails",
      "pro-9000000": "MD Pro 9M Emails",
      "pro-20000000": "MD Pro 20M Emails",
      "pro-6000000": "MD Pro 6M Emails",
      "total-7000000": "MD Total 7M Emails",
      "total-9000000": "MD Total 9M Emails",
      "total-6000000": "MD Total 6M Emails",
      "total-20000000": "MD Total 20M Emails",
      "adhoc-pro-8000000-advanced-test-no-excess":
        "MD Pro 8M Emails Advanced Tests No Email Excess",
      "total-2000000-facade": "MD Total más de 1M Emails",
      "lite-2000000-facade": "MD Lite más de 1M Emails",
      "pro-2000000-facade": "MD Pro más de 1M Emails",
      "adhoc-pro-5000000-advanced-test": "MD Pro 5M Emails Advanced-test",
      "adhoc-pro-3000000-advanced-test": "MD Pro 3M Emails Advanced-test",
      "emblue-25000000": "License emBlue",
      suspended: "Service suspended",
      relocated: "Account relocated",
    },

    getProductLabelFromId: function (id) {
      var name = this.PRODUCTS[id];
      if (!name) {
        return null;
      }
      return name;
    },
  };

  module.exports = ProductsHelper;
});

